/** Subscription / feature gate React Query key factory. */
export const subscriptionInfoQueryKeys = {
  all: ['subscription-info'] as const,
  byUser: (userId: string | null) => [...subscriptionInfoQueryKeys.all, userId] as const,
  plans: () => [...subscriptionInfoQueryKeys.all, 'plans'] as const,
};
